import React, { useEffect, useRef, useState } from 'react';
import { Modal, ActionButton, Field, Text } from 'components/commons';
import { Grid } from '@material-ui/core';
import SelectCustomer from 'components/field/select-customer/select-customer';
import locale from 'localization';
import styles from './transaction-entry-members-modal.module.scss';
import CloseIcon from '@material-ui/icons/Close';
import { formatAmount, parseNumber } from 'utils';
import { InputAmount } from 'components/field';
import Textfield from 'components/commons/textfield/textfield';

const TransactionEntryMembersModal = ({ accountId, close, active, members = [], setMembers, type }) => {
  const [localMembers, setLocalMembers] = useState(members);
  const validateTimeoutRef = useRef(null);
  const [isError, setIsError] = useState(null);

  const addMember = () => {
    setLocalMembers([...localMembers, { id: '', name: '', amount: '', balance: 0 }]);
  };

  const removeMember = (index) => {
    setLocalMembers(localMembers.filter((_, i) => i !== index));
  };

  const handleMemberChange = (
    index,
    field,
    value,
    label = '',
    balance = 0,
    customerAccountNumber = '',
    customerId = '',
    lastName = '',
    firstName = '',
    customerAccountId = ''
  ) => {
    setLocalMembers((prev) =>
      prev.map((m, i) => {
        if (i !== index) return m;

        const updated = { ...m };

        if (field === 'id') {
          updated.id = value;
          updated.name = label;
          updated.balance = balance;
          updated.customerAccountNumber = customerAccountNumber;
          updated.customerId = customerId;
          updated.lastName = lastName;
          updated.firstName = firstName;
          updated.type = type;
          updated.customerAccountId = customerAccountId;
        }

        // If field is amount input
        else if (field === 'amount') {
          updated.amount = value;
        }

        return updated;
      })
    );
  };

  // 🔹 Validate duplicate customers
  const handleCustomerSelect = (index, selected) => {
    const { value, label, balance, customerAccountNumber, customerId, lastName, firstName, customerAccountId } = selected;

    const isDuplicate = localMembers.some((m, i) => m.id === value && i !== index);
    if (isDuplicate) {
      alert('This customer is already selected.');
      return;
    }

    // Pass to handler (will only assign balance if not yet set)
    handleMemberChange(
      index,
      'id',
      value,
      label,
      balance,
      customerAccountNumber,
      customerId,
      lastName,
      firstName,
      customerAccountId
    );
  };

  // 🔹 Validate amount not greater than customer balance
  const handleAmountChange = (index, value) => {
    const current = localMembers[index];
    const numericValue = parseNumber(value);

    // if (numericValue > parseNumber(current.balance) &&) {
    //   alert(`Amount exceeds ${current.name || 'member'}'s balance (₱${formatAmount(current.balance, null)}).`);

    //   // 🔹 Clear invalid amount
    //   setLocalMembers((prev) => prev.map((m, i) => (i === index ? { ...m, amount: '' } : m)));
    //   return;
    // }

    handleMemberChange(index, 'amount', value);
  };

  const handleSave = () => {
    // 🔹 Validate any empty or invalid entries before saving
    for (const m of localMembers) {
      if (!m.id) {
        alert('Please select all members before saving.');
        return;
      }
      // if (!m.amount || parseNumber(m.amount) <= 0) {
      //   alert(`Please enter a valid amount for ${m.name || 'a member'}.`);
      //   return;
      // }

      // if (!m.amount) {
      //   alert(`Please enter a valid amount for ${m.name || 'a member'}.`);
      //   return;
      // }

      // if (parseNumber(m.amount) > parseNumber(m.balance)) {
      //   alert(`Amount for ${m.name} exceeds available balance.`);
      //   return;
      // }
    }

    const totalAmount = localMembers.reduce((sum, m) => sum + parseNumber(m.amount), 0);

    setMembers(localMembers, totalAmount);
    close();
  };

  useEffect(() => {
    if (active) {
      setLocalMembers([...members]);
    }
  }, [active, members]);

  const totalAmount = localMembers.reduce((sum, m) => sum + parseNumber(m.amount), 0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const validateAllBalances = () => {
    if (type === 'debit' && accountId === 402) {
      const invalidMember = localMembers.find((m) => parseNumber(m.amount) !== parseNumber(m.balance));

      if (invalidMember) {
        setIsError(`For Shared Capital Withdrawals, each member's amount must equal their balance.`);
        return;
      }
    }

    setIsError(null);
  };

  useEffect(() => {
    if (validateTimeoutRef.current) clearTimeout(validateTimeoutRef.current);

    validateTimeoutRef.current = setTimeout(() => {
      validateAllBalances();
    }, 500);

    return () => {
      if (validateTimeoutRef.current) clearTimeout(validateTimeoutRef.current);
    };
  }, [localMembers, type, accountId, validateAllBalances]);

  return (
    <Modal active={active} title="Select Members" close={close} className={styles.modal}>
      <div className={styles.content}>
        {localMembers.map((m, i) => (
          <Grid container direction="row" spacing={2} key={i} alignItems="center">
            <Grid item xs={12} sm={5}>
              <Field label={'Member'}>
                <SelectCustomer
                  accountId={accountId}
                  value={m.id}
                  label={m.name}
                  onChange={(name, selected) => handleCustomerSelect(i, selected)}
                  isPostable
                />
              </Field>
            </Grid>

            <Grid item xs={12} sm={3}>
              <Field label="Balance">
                <Textfield value={formatAmount(m?.balance || 0, null)} disabled />
              </Field>
            </Grid>

            <Grid item xs={12} sm={3}>
              <Field label="Amount">
                <InputAmount value={m.amount} onChange={(name, { value }) => handleAmountChange(i, value)} />
              </Field>
            </Grid>

            <Grid item xs={12} sm={1}>
              <div className={styles.remove} onClick={() => removeMember(i)}>
                <CloseIcon />
              </div>
            </Grid>
          </Grid>
        ))}

        {!isError ? (
          <div className={styles.addMemberBtn} onClick={addMember}>
            + Add Member
          </div>
        ) : (
          <Text label>{isError}</Text>
        )}

        <div className={styles.totalRow}>
          <strong>Total:</strong> ₱{formatAmount(totalAmount, null)}
        </div>
      </div>

      <ActionButton
        right
        items={[
          { text: locale.cancel, onClick: close },
          { text: locale.save, onClick: handleSave, disabled: isError }
        ]}
      />
    </Modal>
  );
};

export default TransactionEntryMembersModal;
